/**
 * The initial values for the redux state.
 */
export default {
  data: [],
  isLoading: false
};
